import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { utilitiesAction } from "../../../redux/utilities-slice";

function TransitionLeft(props) {
   return <Slide {...props} />;
}

const ReportingComponent = () => {
   const dispatch = useDispatch();

   const {
      utilities: {
         reporting: { text, isReporting, type },
      },
   } = useSelector((state) => state);

   const closeSnackBar = () => {
      dispatch(
         utilitiesAction.setReporting({
            text: "",
            isReporting: false,
            type: "info",
         })
      );
   };
   return (
      <Snackbar
         open={isReporting}
         autoHideDuration={3000}
         onClose={closeSnackBar}
         anchorOrigin={{ vertical: "top", horizontal: "center" }}
         TransitionComponent={TransitionLeft}
      >
         <Alert onClose={closeSnackBar} severity={type} sx={{ width: "100%" }}>
            {text}
         </Alert>
      </Snackbar>
   );
};

export default ReportingComponent;
